import z from "zod";
import { addressSchema } from "./addressSchema.js";
export const companySchema = z
    .object({
    name: z
        .string()
        .nonempty("Company name is required")
        .min(3, "A minimum of 3 characters is required"),
    address: addressSchema.optional(),
    email: z.string().email("Invalid email address").optional().nullable(),
    phone: z.string().optional().nullable(),
    systemPrompt: z.string().optional(),
    promptFoundation: z.string().optional(),
    assignedTools: z.array(z.string()).optional(),
    voice: z.string().optional(),
    model: z.string().optional(),
    numberId: z.string().optional().nullable(),
    sessionRecordingEnabled: z.boolean().optional(),
    greetOnConnectEnabled: z.boolean().optional(),
})
    .refine((data) => {
    // If address line1 is provided, require city, state, and postalCode
    if (data.address?.line1 && data.address.line1.trim()) {
        return (data.address.city?.trim() &&
            data.address.state?.trim() &&
            data.address.postalCode?.trim());
    }
    return true;
}, {
    message: "City, state, and postal code are required when address line 1 is provided",
    path: ["address"],
});
// export type Company = z.infer<typeof companySchema>;
